import { useAuth } from "~/composables/useAuth";

export default defineNuxtRouteMiddleware(() => {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated()) {
    return navigateTo("/login?from=v4");
  }
});
